export enum InvoiceVerificationStatusEnum {
    ALL = 'ALL',
    ACT_RECONCILIATION_NOT_FOUND = 'ACT_RECONCILIATION_NOT_FOUND',
    SIGNED_AMOUNT_NOT_FOUND = 'SIGNED_AMOUNT_NOT_FOUND',
    SIGNED_AMOUNT_MISMATCH = 'SIGNED_AMOUNT_MISMATCH',
    NUMBER_ACT_MISMATCH = 'NUMBER_ACT_MISMATCH',
    APPROVE_DATE_MISMATCH = 'APPROVE_DATE_MISMATCH',
    INVALID_INVOICE_ID = 'INVALID_INVOICE_ID',
    SUCCESSFUL = 'SUCCESSFUL'
}
